import { DataBean } from "../DataBean";

export class ReverseAccIcomeDoc extends DataBean {



    public async reverseAccountantIncomeDocument(iadIDDocument: any, iadDocumentDate: any, accountantDate: any, description: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_reverseAccountantIncomeDocument_Number_java.util.Date_java.util.Date_String_Number", [iadIDDocument, iadDocumentDate, accountantDate, description, idEmployee]);
    }

}